/** Unique keys for "traffic" module's DTOs */
export enum TrafficsDtoKeysEnum {
  // Adapters
  ADAPTER_FILTERS_DTO = 'traffic/adapter-filters.dto',
  ADAPTER_QUERY_DTO = 'traffic/adapter-query.dto',
  ADAPTER_FIND_DTO = 'traffic/adapter-find.dto',
  ADAPTER_PAGE_DTO = 'traffic/adapter-page.dto',
  ADAPTER_FORM_DTO = 'traffic/adapter-form.dto',
  ADAPTER_PARTIAL_FORM_DTO = 'traffic/adapter-partial-form.dto',
  // Sensors
  SENSOR_FILTERS_DTO = 'traffic/sensor-filters.dto',
  SENSOR_QUERY_DTO = 'traffic/sensor-query.dto',
  SENSOR_FIND_DTO = 'traffic/sensor-find.dto',
  SENSOR_PAGE_DTO = 'traffic/sensor-page.dto',
  SENSOR_FORM_DTO = 'traffic/sensor-form.dto',
  SENSOR_PARTIAL_FORM_DTO = 'traffic/sensor-partial-form.dto',
  // Traffic
  TRAFFIC_FILTERS_DTO = 'traffic/traffic-filters.dto',
  TRAFFIC_QUERY_DTO = 'traffic/traffic-query.dto',
  TRAFFIC_FIND_DTO = 'traffic/traffic-find.dto',
  TRAFFIC_PAGE_DTO = 'traffic/traffic-page.dto',
  TRAFFIC_FORM_DTO = 'traffic/traffic-form.dto',
  // Traffic report
  TRAFFIC_REPORT_QUERY_DTO = 'traffic/traffic-report-query.dto',
  TRAFFIC_REPORT_FIND_DTO = 'traffic/traffic-report-find.dto',
  TRAFFIC_REPORT_PAGE_DTO = 'traffic/traffic-report-page.dto',
  TRAFFIC_REPORT_SUMS_FIND_DTO = 'traffic/traffic-report-sums-find.dto',
  TRAFFIC_REPORT_CHART_FIND_DTO = 'traffic/traffic-report-chart-find.dto',
}
